var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMandatoryName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#87b8ea",
    d: "M21,11h-5.001c-1.657,0-3,1.343-3,3v7.001c0,1.656,1.343,2.999,2.999,3l5,.003c1.657,0,3.002-1.343,3.002-3v-7.003c0-1.657-1.343-3-3-3Zm-4.001,2.997h3c.552,0,1,.448,1,1,0,.552-.448,1-1,1h-3c-.552,0-1-.448-1-1,0-.552,.448-1,1-1Zm3,6.003h-3c-.552-.001-1-.449-1-1.001h0c0-.554,.448-1.002,1-1.002h3c.552,0,1,.448,1,1v.003c0,.552-.448,1-1,1Zm-10.999-8c3.309,0,6-2.691,6-6S12.309,0,9,0,3,2.691,3,6s2.691,6,6,6Zm0-9c1.654,0,3,1.346,3,3s-1.346,3-3,3-3-1.346-3-3,1.346-3,3-3Zm2,12.472c.016,.828-.644,1.512-1.472,1.527l-1.047,.02c-2.896,.21-5.288,2.61-5.484,5.58-.053,.793-.713,1.401-1.495,1.401-.034,0-.067,0-.102-.003-.826-.055-1.452-.769-1.397-1.596,.296-4.457,3.882-8.058,8.343-8.377l1.126-.023c.845-.048,1.513,.643,1.528,1.472Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandatoryName);
export default __webpack_public_path__ + "static/media/mandatoryName.5b482606757b26ebc5f4bf40cc1aa4fa.svg";
export { ForwardRef as ReactComponent };